var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden && !_vm.loading && _vm.enabled
    ? _c("div", [
        _vm.recommendedFiles.length > 0
          ? _c(
              "div",
              { staticClass: "group", attrs: { id: "recommendations" } },
              _vm._l(_vm.recommendedFiles, function(file) {
                return _c("RecommendedFile", {
                  key: file.id,
                  attrs: {
                    id: file.id,
                    extension: file.extension,
                    "mime-type": file.mimeType,
                    name: file.name,
                    directory: file.directory,
                    reason: file.reason,
                    "has-preview": file.hasPreview
                  }
                })
              }),
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }